<script setup lang="ts">
import FormDataBloqueada from '../components/form-databloqueada.vue'
import { useDataBloqueadaStore } from '../store/useDataBloqueadaStore'

definePage({
  meta: {
    navActiveLink: 'admin-data-bloqueada',
    action: 'edit',
    subject: 'data-bloqueada',
  },
})

const store = useDataBloqueadaStore()
const router = useRouter()

const {
  fetchItem,
} = store

fetchItem(router.currentRoute.value.params.id)
</script>

<template>
  <FormDataBloqueada is-editing />
</template>
